import clsx from 'clsx';

export const FieldWrapper = (props) => {
  const { label, className, error, children } = props;
  return (
    <div className="">
      <label
        className={clsx('block text-sm font-medium text-gray-700 dark:text-gray-400', className)}
      >
        <div className="mx-1">{label}</div>
        <div className="mt-1">{children}</div>
      </label>
      {error?.message && (
        <div role="alert" aria-label={error.message} className="text-sm mx-8 font-semibold text-red-500">
          {error.message}
        </div>
      )}
    </div>
  );
};
